import {
  BooleanInput,
  Button,
  required,
  SelectArrayInput,
  TextInput,
  Toolbar,
  useDataProvider,
  useNotify,
} from "react-admin";
import { Card, CircularProgress, Grid, makeStyles } from "@material-ui/core";
import * as React from "react";
import { Separator } from "../../../../src/Components/Separator";
import { SectionTitle } from "../../../../src/Components/SectionTitle";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import { Add } from "@material-ui/icons";
import { SourceQuarantineReasonList } from "../Constant/Source";
import { Form } from "react-final-form";
import { QuarantinePutModel } from "../Model/QuarantineModel";
import { QuarantineDetailCreate } from "../Model/QuarantineDetailModel";
import { useAppDataProvider } from "../../../../src/dataprovider";
import { QuarantineReasons } from "../../../../src/Enums/QuarantineReasons";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const QuarantineEditForm = props => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const provider = useDataProvider();
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const [quarantineReasons, setQuarantineReasons] = useState([] as any);
  const [selectedReasons, setSelectedReasons] = useState<Number[]>([]);
  const [remarkRequired, setRemarkRequired] = useState(false);
  const validate = [];

  const useStyles = makeStyles({
    toolbar: {
      display: "flex",
      justifyContent: "end",
      backgroundColor: "white",
    },
    defaultToolbar: {
      display: "flex",
      justifyContent: "end",
    },
  });

  const classes = useStyles();

  React.useEffect(() => {
    provider
      .getList(SourceQuarantineReasonList, {
        pagination: { page: 1, perPage: 999 },
        sort: { field: "id", order: "DESC" },
        filter: {},
      })
      .then(response => {
        if (response.data.length > 0) {
          setQuarantineReasons(response.data);
        }
      })
      .catch(error => {
        console.log(error);
      });
  }, []);

  React.useEffect(() => {
    provider
      .getList("quarantinedetails", {
        pagination: { page: 1, perPage: 999 },
        sort: { field: "id", order: "DESC" },
        filter: { quarantineId__eq: props.id },
      })
      .then(response => {
        var selectedReason: number[] = [];

        if (response.data.length > 0) {
          response.data.forEach(element => {
            selectedReason.push(element.quarantineReasonId);
          });
          setSelectedReasons(selectedReason);
        }
      })
      .catch(error => {
        console.log(error);
      });
  }, []);

  const changeQuarantineReason = form => value => {
    const formValue = form?.getState?.()?.values ?? {};

    if (formValue.quarantineReasons.find(condition => condition == QuarantineReasons.Other) !== undefined) {
      setRemarkRequired(true);
    } else {
      setRemarkRequired(false);
    }
  };

  const UpdateQuarantineButtonClick = e => {
    UpdateQuarantine(e);
  };

  const UpdateQuarantine = async e => {
    let quarantineEditModel: QuarantinePutModel = new QuarantinePutModel();
    let requestReasonListCreate = [] as QuarantineDetailCreate[];

    var final_reasons = e.quarantineReasons.filter(item => !selectedReasons.includes(item));

    final_reasons.forEach(reason => {
      let quarantineDetailModel: QuarantineDetailCreate = new QuarantineDetailCreate();
      quarantineDetailModel.QuarantineId = props.record.id;
      quarantineDetailModel.QuarantineReasonId = reason;
      quarantineDetailModel.QuarantineReasonStatus = 0; // Status 0 Open
      requestReasonListCreate.push(quarantineDetailModel);
    });

    quarantineEditModel.Id = props.record.id;
    quarantineEditModel.RefNo = e.refNo;
    quarantineEditModel.QuarantineReasons = requestReasonListCreate;
    quarantineEditModel.CustomerName = e.customerName;
    quarantineEditModel.CustomerPo = e.customerPo;
    quarantineEditModel.UnitType = e.unitType;
    quarantineEditModel.UnproperPacking = e.unproperPacking;
    quarantineEditModel.QuarantineRemark = e.quarantineRemark;
    quarantineEditModel.Pn = e.pn;
    quarantineEditModel.Sn = e.sn;
    quarantineEditModel.AwbNo = e.awbNo;
    quarantineEditModel.Location = e.location;
    quarantineEditModel.IsActive = true;

    dataProvider
      .putQuarantine(quarantineEditModel)
      .then(result => {
        notify(`Record Updated`, "success", false, true);
        history.push("/quarantines");
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  return (
    <Form
      onSubmit={UpdateQuarantineButtonClick}
      render={({ handleSubmit, form, values }) => (
        <Card>
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <>
                  <Separator />
                  <Grid {...gridContainerProps}>
                    <SectionTitle label="Quarantine" />
                  </Grid>
                  <Separator />

                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}></Grid>
                    <Grid item xs={12} sm={5}>
                      <BooleanInput
                        label="UNPROPER PACKING"
                        source="unproperPacking"
                        disabled
                        defaultValue={props.record.unproperPacking}
                        fullWidth
                      />
                    </Grid>
                  </Grid>

                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="refNo"
                        label="REFERENCE NUMBER"
                        fullWidth
                        resettable
                        variant="outlined"
                        disabled={props.record.refNo === null ? false : true}
                        //validate={required()}
                      />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      {selectedReasons.length > 0 && (
                        <SelectArrayInput
                          source="quarantineReasons"
                          choices={quarantineReasons}
                          optionText="quarantineReasonName"
                          optionValue="quarantineReasonEnum"
                          defaultValue={selectedReasons}
                          onChange={changeQuarantineReason(form)}
                          validate={required()}
                          fullWidth
                        />
                      )}
                    </Grid>
                  </Grid>
                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="customerName"
                        label="CUSTOMER NAME"
                        fullWidth
                        resettable
                        disabled
                        variant="outlined"
                        validate={required()}
                      />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="customerPo"
                        label="CUSTOMER PO"
                        fullWidth
                        resettable
                        disabled
                        variant="outlined"
                        validate={required()}
                      />
                    </Grid>
                  </Grid>
                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="pn"
                        label="PN"
                        fullWidth
                        resettable
                        disabled
                        variant="outlined"
                        validate={required()}
                      />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="sn"
                        label="SN"
                        fullWidth
                        resettable
                        disabled
                        variant="outlined"
                        validate={required()}
                      />
                    </Grid>
                    <Grid item xs={12} sm={5} />
                  </Grid>
                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="awbNo"
                        label="AWB Number"
                        fullWidth
                        resettable
                        disabled
                        variant="outlined"
                        validate={required()}
                      />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="location"
                        label="LOCATION"
                        fullWidth
                        resettable
                        disabled
                        variant="outlined"
                        validate={required()}
                      />
                    </Grid>
                  </Grid>
                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      <TextInput source="unitType" fullWidth disabled variant="outlined" />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="quarantineRemark"
                        label="QUARANTINE REMARKS"
                        multiline
                        fullWidth
                        resettable
                        variant="outlined"
                        validate={remarkRequired == true ? required() : validate}
                      />
                    </Grid>
                  </Grid>

                  <Separator />
                  <Toolbar {...props} placeholder="" classes={classes}>
                    <Button
                      label={loading ? "Quarantine is updating!" : "Update Quarantine"}
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      color="primary"
                      onClick={handleSubmit}
                      style={{ margin: "8px", background: "#ffc107" }}
                    >
                      {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                    </Button>
                  </Toolbar>
                </>
              </Grid>
            </Grid>
          </form>
        </Card>
      )}
    />
  );
};

export default QuarantineEditForm;
